import AlertsStack from './AlertsStack';

export type { IAlert } from './AlertsStack.types';
export default AlertsStack;
